// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__body___tS4iV {
  display: flex;
  flex-flow: row wrap;
  padding-bottom: 20px;
  padding-top: 59px;
}

.styles__body___tS4iV:before {
  content: '';
  display: table;
}

.styles__body___tS4iV:after {
  content: '';
  display: table;
  clear: both;
}

.styles__bodyAlt___VIHPZ {
  display: flex;
  flex-flow: row wrap;
  padding-bottom: 20px;
  padding-top: 110px;
}

.styles__bodyAlt___VIHPZ:before {
  content: '';
  display: table;
}

.styles__bodyAlt___VIHPZ:after {
  content: '';
  display: table;
  clear: both;
}

.styles__card___rVeDc {
  width: 100%;
}

.styles__sectionTitle___WztHI {
}

.styles__bodyLeft___NsSlm {
}
.styles__bodyLeftAlt___IsoPN {
}

.styles__bodyRight___W5yTd {
}
.styles__bodyRightAlt___v7tzA {
}

.styles__header___Zc1pX {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  border-top: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  left: 0;
  padding: 10px 0;
  position: fixed;
  right: 0;
  z-index: 100;
}
.styles__headerLeft___nPMPq {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.styles__headerStepper___Kw9w4 {
  width: calc(99.9% * 2/5 - (30px - 30px * 2/5));
  width: 100%;
}
.styles__headerStepper___Kw9w4:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}
.styles__headerStepper___Kw9w4:last-child {
  margin-right: 0;
}
.styles__headerStepper___Kw9w4:nth-child(5n) {
  margin-right: 0;
  float: right;
}
.styles__headerStepper___Kw9w4:nth-child(5n + 1) {
  clear: both;
}
.styles__headerInner___KWfSw {
  display: flex;
  /* justify-content: space-between; */
  padding-bottom: 0;
  padding-top: 0;
}
.styles__headerInner___KWfSw h5 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
    text-transform: capitalize;
  }
.styles__headerInnerTitle___YKlWT {
  text-transform: uppercase;
  font-weight: 500;
}

.styles__ticketStatusLabel___qS7D2 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
  font-size: 12px;
}
.styles__headerLeftTitle___ubs2_ {
  margin: 0.4rem 0 0.4rem 0 !important;
  font-weight: 700;
}

.styles__ticketStatus____Ypnh {
  color: white;
  text-transform: capitalize;
}

.styles__statusPending___cJ_Oo {
  margin-left: 10px;
}

.styles__statusDanger___rUU0_ {
  margin-left: 10px;
}

.styles__statusPositive___UoaoI {
  margin-left: 10px;
}

.styles__refWrap___clhmz {
  bottom: 20px;
  overflow: auto;
  padding-right: 10px;
  position: fixed;
  top: 109px;
  width: 462.86px;
}

@media (max-width: 1450px) {

.styles__refWrap___clhmz {
    width: 32%;
}
  }

@media (max-width: 1000px) {

.styles__refWrap___clhmz {
    width: 38%;
}
  }

.styles__events___NLVcr {
  list-style-type: none;
  margin: 0;
  max-height: 200px;
  overflow: auto;
  padding: 0;
}

.styles__event___XgA95 {
  display: inline-block;
}

.styles__event___XgA95::first-letter {
    text-transform: capitalize;
  }
.styles__eventStyleWrapper___SZKmb {
  width: 100% !important;
}

.styles__timeStamp___XwXBd {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 12px;
}

.styles__user___XfVtS {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 12px;
  text-transform: capitalize;
}

.styles__meta___qxwEe {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3px;
}

.styles__eventWrapper___UX8Qd {
  background: white;
  border-left: 4px solid gtYellow;
}

.styles__eventRejected___qbvL7 {
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.styles__eventPositive___sp6JH {
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
}
`, "",{"version":3,"sources":["webpack://./universal/components/Ticket/styles.css"],"names":[],"mappings":"AAIA;EAEE,aAAwB;EAAxB,mBAAwB;EAExB,oBAAoB;EACpB,iBAAiB;AACnB;;AANA;EAGE,WAAsB;EAAtB,cAAsB;AAGxB;;AANA;EAGE,WAAsB;EAAtB,cAAsB;EAAtB,WAAsB;AAGxB;;AAEA;EAEE,aAAwB;EAAxB,mBAAwB;EAExB,oBAAoB;EACpB,kBAAkB;AACpB;;AANA;EAGE,WAAsB;EAAtB,cAAsB;AAGxB;;AANA;EAGE,WAAsB;EAAtB,cAAsB;EAAtB,WAAsB;AAGxB;;AAEA;EAEE,WAAW;AACb;;AAEA;AAEA;;AAEA;AAEA;AACA;AAEA;;AAEA;AAEA;AACA;AAEA;;AAEA;EACE,wDAAuB;EACvB,qEAA+B;EAC/B,kEAA4B;EAC5B,OAAO;EACP,eAAe;EACf,eAAe;EACf,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,8CAAgB;EAChB,WAAW;AACb;AAHA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAElB;AAHA;EACE,eAAgB;AAElB;AAHA;EACE,eAAgB;EAAhB,YAAgB;AAElB;AAHA;EACE,WAAgB;AAElB;AACA;EAEE,aAAa;EACb,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;AAMhB;AAJE;IACE,mDAAiB;IACjB,0BAA0B;EAC5B;AAEF;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mDAAkB;EAClB,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,eAAe;AASjB;;AAPE;;AARF;IASI,UAAU;AAMd;EALE;;AAEA;;AAZF;IAaI,UAAU;AAEd;EADE;;AAGF;EACE,qBAAqB;EACrB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,qBAAqB;AAKvB;;AAHE;IACE,0BAA0B;EAC5B;AAEF;EACE,sBAAsB;AACxB;;AAEA;EACE,mDAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mDAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AAEjC;;AAEA;EACE,0DAAmB;AAErB;;AAEA;EACE,0DAAqB;AAEvB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtBlueLight, gtGray, textLight, gtBlueDark, gtRed, gtGreen from colors;\n\n.body {\n  composes: content-container from helpers;\n  lost-flex-container: row;\n  lost-utility: clearfix;\n  padding-bottom: 20px;\n  padding-top: 59px;\n}\n\n.bodyAlt {\n  composes: content-container from helpers;\n  lost-flex-container: row;\n  lost-utility: clearfix;\n  padding-bottom: 20px;\n  padding-top: 110px;\n}\n\n.card {\n  composes: card from helpers;\n  width: 100%;\n}\n\n.sectionTitle {\n  composes: sectionTitle from helpers;\n}\n\n.bodyLeft {\n  composes: bodyLeft from helpers;\n}\n.bodyLeftAlt {\n  composes: bodyLeftAlt from helpers;\n}\n\n.bodyRight {\n  composes: bodyRight from helpers;\n}\n.bodyRightAlt {\n  composes: bodyRightAlt from helpers;\n}\n\n.header {\n  background: gtBlueLight;\n  border-bottom: 1px solid gtGray;\n  border-top: 1px solid gtGray;\n  left: 0;\n  padding: 10px 0;\n  position: fixed;\n  right: 0;\n  z-index: 100;\n}\n.headerLeft {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.headerStepper {\n  lost-column: 2/5;\n  width: 100%;\n}\n.headerInner {\n  composes: content-container from helpers;\n  display: flex;\n  /* justify-content: space-between; */\n  padding-bottom: 0;\n  padding-top: 0;\n\n  h5 {\n    color: gtBlueDark;\n    text-transform: capitalize;\n  }\n}\n.headerInnerTitle {\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n.ticketStatusLabel {\n  color: gtBlueLight;\n  font-size: 12px;\n}\n.headerLeftTitle {\n  margin: 0.4rem 0 0.4rem 0 !important;\n  font-weight: 700;\n}\n\n.ticketStatus {\n  color: white;\n  text-transform: capitalize;\n}\n\n.statusPending {\n  composes: statusPending from helpers;\n  margin-left: 10px;\n}\n\n.statusDanger {\n  composes: statusRejected from helpers;\n  margin-left: 10px;\n}\n\n.statusPositive {\n  composes: statusActive from helpers;\n  margin-left: 10px;\n}\n\n.refWrap {\n  bottom: 20px;\n  overflow: auto;\n  padding-right: 10px;\n  position: fixed;\n  top: 109px;\n  width: 462.86px;\n\n  @media (max-width: 1450px) {\n    width: 32%;\n  }\n\n  @media (max-width: 1000px) {\n    width: 38%;\n  }\n}\n\n.events {\n  list-style-type: none;\n  margin: 0;\n  max-height: 200px;\n  overflow: auto;\n  padding: 0;\n}\n\n.event {\n  display: inline-block;\n\n  &::first-letter {\n    text-transform: capitalize;\n  }\n}\n.eventStyleWrapper {\n  width: 100% !important;\n}\n\n.timeStamp {\n  color: textLight;\n  font-size: 12px;\n}\n\n.user {\n  color: textLight;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n\n.meta {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 3px;\n}\n\n.eventWrapper {\n  background: white;\n  border-left: 4px solid gtYellow;\n  composes: noteWrapper from helpers;\n}\n\n.eventRejected {\n  border-color: gtRed;\n  composes: eventWrapper;\n}\n\n.eventPositive {\n  border-color: gtGreen;\n  composes: eventWrapper;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"body": `styles__body___tS4iV ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"bodyAlt": `styles__bodyAlt___VIHPZ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"card": `styles__card___rVeDc ${___CSS_LOADER_ICSS_IMPORT_1___.locals["card"]}`,
	"sectionTitle": `styles__sectionTitle___WztHI ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"bodyLeft": `styles__bodyLeft___NsSlm ${___CSS_LOADER_ICSS_IMPORT_1___.locals["bodyLeft"]}`,
	"bodyLeftAlt": `styles__bodyLeftAlt___IsoPN ${___CSS_LOADER_ICSS_IMPORT_1___.locals["bodyLeftAlt"]}`,
	"bodyRight": `styles__bodyRight___W5yTd ${___CSS_LOADER_ICSS_IMPORT_1___.locals["bodyRight"]}`,
	"bodyRightAlt": `styles__bodyRightAlt___v7tzA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["bodyRightAlt"]}`,
	"header": `styles__header___Zc1pX`,
	"headerLeft": `styles__headerLeft___nPMPq`,
	"headerStepper": `styles__headerStepper___Kw9w4`,
	"headerInner": `styles__headerInner___KWfSw ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"headerInnerTitle": `styles__headerInnerTitle___YKlWT`,
	"ticketStatusLabel": `styles__ticketStatusLabel___qS7D2`,
	"headerLeftTitle": `styles__headerLeftTitle___ubs2_`,
	"ticketStatus": `styles__ticketStatus____Ypnh`,
	"statusPending": `styles__statusPending___cJ_Oo ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusPending"]}`,
	"statusDanger": `styles__statusDanger___rUU0_ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusRejected"]}`,
	"statusPositive": `styles__statusPositive___UoaoI ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"refWrap": `styles__refWrap___clhmz`,
	"events": `styles__events___NLVcr`,
	"event": `styles__event___XgA95`,
	"eventStyleWrapper": `styles__eventStyleWrapper___SZKmb`,
	"timeStamp": `styles__timeStamp___XwXBd`,
	"user": `styles__user___XfVtS`,
	"meta": `styles__meta___qxwEe`,
	"eventWrapper": `styles__eventWrapper___UX8Qd ${___CSS_LOADER_ICSS_IMPORT_1___.locals["noteWrapper"]}`,
	"eventRejected": `styles__eventRejected___qbvL7 styles__eventWrapper___UX8Qd ${___CSS_LOADER_ICSS_IMPORT_1___.locals["noteWrapper"]}`,
	"eventPositive": `styles__eventPositive___sp6JH styles__eventWrapper___UX8Qd ${___CSS_LOADER_ICSS_IMPORT_1___.locals["noteWrapper"]}`
};
export default ___CSS_LOADER_EXPORT___;
